import { render, staticRenderFns } from "./DashboardExclusionDialog.vue?vue&type=template&id=6ba005b0&scoped=true&"
import script from "./DashboardExclusionDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardExclusionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba005b0",
  null
  
)

export default component.exports